export const ISLAND = 'ISLAND'
export const CONTINUOUS = 'CONTINUOUS'

export const HIGH_WATER = 'HIGH_WATER'
export const LOW_WATER = 'LOW_WATER'
